import { render } from "./TwoColumnTextImage.vue?vue&type=template&id=6424492c&scoped=true"
import script from "./TwoColumnTextImage.vue?vue&type=script&lang=js"
export * from "./TwoColumnTextImage.vue?vue&type=script&lang=js"

import "./TwoColumnTextImage.vue?vue&type=style&index=0&id=6424492c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6424492c"]])

export default __exports__